import React from 'react';
import './AllArticles.css'
import GoToTop from "../Support/GoToTop";

const Sacraments = () => {
    return (
        <article className="article">
            <header>
                <h1>Are the Sacraments Biblical?</h1>
                <p className="author">By Jakob Puckett</p>
            </header>

            <section>
                <p>
                    Orthodox Christians live their lives observing the sacraments, or more commonly called in Orthodoxy, the mysteries of the church. Since God acts through them, our participation in the mysteries is participation in the life that God has established for us.
                </p>
                <p>
                    This is often puzzling to those not familiar with the sacraments. Are we trying to earn our way to heaven? And are we adding extra requirements for the Christian life than those from the Bible?
                </p>
                <p>
                    To begin, the sacraments are vehicles of grace, or means by which God acts in the world. The underlying principle is that God works through the material world. As is affirmed throughout the Bible, God uses people and things to communicate his grace (his power and activity). This means that the sacraments are more than mere symbols – they actually “do” something, because God is actually working through them.
                </p>
            </section>

            <section>
                <h2>The Seven Sacraments</h2>
                <ul>
                    <li>Baptism</li>
                    <li>Chrismation</li>
                    <li>Confession</li>
                    <li>The Eucharist</li>
                    <li>The Priesthood</li>
                    <li>Marriage</li>
                    <li>Unction (Healing)</li>
                </ul>
                <p>
                    When we turn to the Bible and look at their divine institution, we can see how God uses them to do things that the material objects themselves are incapable of doing.
                </p>
            </section>

            <section>
                <h3>Baptism</h3>
                <p>
                    Baptism is the beginning of our Christian lives. Jesus said, “unless one is born of water and the Spirit, he cannot enter the kingdom of God” (John 3:5). Baptism washes away prior sins, regenerates us, and justifies us (Acts 2:37-38, Titus 3:5, 1 Peter 3:21).
                </p>
            </section>

            <section>
                <h3>Chrismation</h3>
                <p>
                    Chrismation fills us with the Holy Spirit, typically through anointing with oil or laying on of hands (Acts 8:14-17, 19:1-6). It is always in conjunction with baptism.
                </p>
            </section>

            <section>
                <h3>Confession</h3>
                <p>
                    God works through appointed men to forgive sins. Jesus gave the apostles authority to bind and loose sins (John 20:23, Matthew 16:19). Confession is a public act and was practiced in apostolic times (James 5:14-16).
                </p>
            </section>

            <section>
                <h3>The Eucharist</h3>
                <p>
                    The Eucharist is the body and blood of Christ. Jesus said, “this is my body” and “this is my blood” (Luke 22:14-22, John 6:53). Through it, we abide in Christ and he in us.
                </p>
            </section>

            <section>
                <h3>The Priesthood</h3>
                <p>
                    The apostles were priests under Christ and appointed successors (Acts 1:23-26, 20:28). This apostolic succession continues today through bishops and priests.
                </p>
            </section>

            <section>
                <h3>Marriage</h3>
                <p>
                    Marriage is a living icon of Christ and the church. It involves unity, self-sacrifice, and participation in God’s creative work (Genesis 2:18-24, Ephesians 5:22-33).
                </p>
            </section>

            <section>
                <h3>Unction (Healing)</h3>
                <p>
                    Anointing with oil provides healing of body and soul. James instructs the sick to call for the elders to pray and anoint them (James 5:13-16).
                </p>
            </section>

            <section>
                <h2>Conclusion</h2>
                <p>
                    The sacraments are visible and identifiable signs of grace. They help us live the Christian life with assurance. Observing them is obedience to God’s institutions, not an addition to his word.
                </p>
                <p className="author-note">
                    Jakob Puckett is a reader in the Coptic Orthodox Church.
                </p>
            </section>
            <GoToTop/>
        </article>
    );
};

export default Sacraments;